function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
import useAxios from "../../../../Hooks/use-axios";
var useData = function useData(dealId, isRewards, appType) {
  var _redux$deals, _redux$auth, _redux$auth2, _redux$auth3;
  var isPublicView = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient;
  var isPoints = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    deal = _useState2[0],
    setDeal = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    bundleDeals = _useState4[0],
    setBundleDeals = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    otherBundleDeals = _useState6[0],
    setOtherBundleDeals = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    bundleDealDetails = _useState8[0],
    setBundleDealDetails = _useState8[1];
  var _useAxios = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingBundleDeals = _useAxios.isLoading,
    fetchBundleDeals = _useAxios.sendRequest;
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    similarOffers = _useState0[0],
    setSimilarOffers = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    topOffers = _useState10[0],
    setTopOffers = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    sameBrandOffers = _useState12[0],
    setSameBrandOffers = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    faultyDeal = _useState14[0],
    setFaultyDeal = _useState14[1];
  var _useAxios2 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingDeal = _useAxios2.isLoading,
    fetchDealDetails = _useAxios2.sendRequest;
  var _useAxios3 = useAxios({
      winnreAuth: winnreAuth,
      cmsClient: cmsClient
    }),
    loadingSimilarDeals = _useAxios3.isLoading,
    fetchSimilarDeals = _useAxios3.sendRequest;
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    cartAmount = _useState16[0],
    setCartAmount = _useState16[1];
  var isRewardRefreshing = redux === null || redux === void 0 || (_redux$deals = redux.deals) === null || _redux$deals === void 0 ? void 0 : _redux$deals.isRefreshRewards;
  var isAuthenticated = redux === null || redux === void 0 || (_redux$auth = redux.auth) === null || _redux$auth === void 0 ? void 0 : _redux$auth.isAuthenticated;
  var totalRewardspoint = isPoints ? redux === null || redux === void 0 || (_redux$auth2 = redux.auth) === null || _redux$auth2 === void 0 ? void 0 : _redux$auth2.reloyRewardPoints : redux === null || redux === void 0 || (_redux$auth3 = redux.auth) === null || _redux$auth3 === void 0 || (_redux$auth3 = _redux$auth3.redux) === null || _redux$auth3 === void 0 || (_redux$auth3 = _redux$auth3.auth) === null || _redux$auth3 === void 0 ? void 0 : _redux$auth3.rewardPoints;
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var stateDeals = (redux === null || redux === void 0 ? void 0 : redux.deals) || {};
  var getDealDetails = function getDealDetails() {
    setFaultyDeal(false);
    var rewardTypeParam = isPoints ? "?rewardType=RELOY_REWARDS" : isRewards ? "?rewardType=REFERRAL_REWARDS" : "";
    fetchDealDetails({
      isEncryptedResponse: true,
      url: isAuthenticated ? "/winnre/user/deals/".concat(dealId).concat(rewardTypeParam) : "/winnre/no-auth/deals/".concat(dealId).concat(rewardTypeParam),
      method: "get"
    }, function (data) {
      var _data$category;
      // console.log(
      //     'desc',
      //     data?.description,
      //     'specs',
      //     data?.productSpecs
      // );
      console.log("deal details", data);
      if ((data === null || data === void 0 ? void 0 : data.status) == "FAILED") {
        setFaultyDeal(true);
        return;
      }
      setDeal(data);
      if ((isAuthenticated || isPublicView) && ((_data$category = data.category) === null || _data$category === void 0 ? void 0 : _data$category.id) !== 4) {
        var _data$category2, _data$category3, _data$rewardCategory, _data$tags$2;
        if ((data === null || data === void 0 || (_data$category2 = data.category) === null || _data$category2 === void 0 ? void 0 : _data$category2.id) == "8") {
          var _data$tags$;
          getBundleDealsWithSameTag(data === null || data === void 0 || (_data$tags$ = data.tags[0]) === null || _data$tags$ === void 0 ? void 0 : _data$tags$.id, data === null || data === void 0 ? void 0 : data.id);
        }
        getSimilarOffersByCategory(data.id, data === null || data === void 0 || (_data$category3 = data.category) === null || _data$category3 === void 0 ? void 0 : _data$category3.id, data === null || data === void 0 || (_data$rewardCategory = data.rewardCategory) === null || _data$rewardCategory === void 0 ? void 0 : _data$rewardCategory.id, data === null || data === void 0 || (_data$tags$2 = data.tags[0]) === null || _data$tags$2 === void 0 ? void 0 : _data$tags$2.id);
        getSameBrandOffers(data.id, data.vendor.id);
      }
    });
  };

  // const getBundleDealsWithSameTag = (id) => {
  //     const url = `/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=8&pageSize=10&tagList=${id}${
  //         isRewards ? '&rewardsPage=true' : ''
  //     }`;
  //     let cachedBundleDeals = state.deals.bundleDealCache[url] || null;
  //     if (cachedBundleDeals) {
  //         // Use cached deals if available
  //         console.log('Using cached bundle deals:', cachedBundleDeals);
  //         setBundleDeals(cachedBundleDeals);
  //         const bundleIds = cachedBundleDeals.map((offer) => offer.id);
  //         let apiCall = Promise.all(
  //             bundleIds?.map((id) =>
  //                 winnreAuth({
  //                     method: 'GET',
  //                     url: `/winnre/user/deals/${id}`
  //                 })
  //             )
  //         );
  //         apiCall.then((res) => {
  //             setBundleDealDetails(res);
  //         });
  //     } else {
  //         fetchBundleDeals(
  //             {
  //                 isEncryptedResponse: isAuthenticated ? true : false,
  //                 url: url,
  //                 method: 'get',
  //                 isFormData: true
  //             },
  //             (res) => {
  //                 setBundleDeals(res?.content);
  //                 dispatch(
  //                     dealAction.saveBundleDeals({
  //                         url,
  //                         deals: res?.content
  //                     })
  //                 );
  //                 const bundleIds = res?.content.map((offer) => offer.id);
  //                 let apiCall = Promise.all(
  //                     bundleIds?.map((id) =>
  //                         winnreAuth({
  //                             method: 'GET',
  //                             url: `/winnre/user/deals/${id}`
  //                         })
  //                     )
  //                 );
  //                 apiCall.then((res) => {
  //                     setBundleDealDetails(res);
  //                 });
  //             }
  //         );
  //     }
  // };

  var getBundleDealsWithSameTag = function getBundleDealsWithSameTag(id, dealId) {
    var _stateDeals$bundleDea;
    var url = "/winnre/user/deals/filter-v2?&status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=8&pageSize=10&tagList=".concat(id).concat(isRewards ? "&rewardsPage=true" : "");
    var cachedBundleDeals = ((_stateDeals$bundleDea = stateDeals.bundleDealCache) === null || _stateDeals$bundleDea === void 0 ? void 0 : _stateDeals$bundleDea[url]) || null;
    if (cachedBundleDeals) {
      console.log("Using cached bundle deals:", cachedBundleDeals);
      var filteredBundleDeals = cachedBundleDeals.filter(function (deal) {
        return (deal === null || deal === void 0 ? void 0 : deal.id) === dealId;
      });
      var _otherBundleDeals = cachedBundleDeals.filter(function (deal) {
        return (deal === null || deal === void 0 ? void 0 : deal.id) !== dealId;
      });

      // console.log("filteredCatchedBundleDeals" , filteredBundleDeals);
      setBundleDeals(filteredBundleDeals);
      setOtherBundleDeals(_otherBundleDeals);
      var bundleIds = filteredBundleDeals.map(function (offer) {
        return offer.id;
      });
      var apiCall = Promise.all(bundleIds.map(function (id) {
        return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
          method: "GET",
          url: "/winnre/user/deals/".concat(id)
        });
      }));
      apiCall.then(function (res) {
        setBundleDealDetails(res);
      });
    } else {
      fetchBundleDeals({
        isEncryptedResponse: isAuthenticated ? true : false,
        url: url,
        method: "get",
        isFormData: true
      }, function (res) {
        var _redux$dealAction;
        // console.log("filteredDeals dealID" , dealId );
        var filteredDeals = res === null || res === void 0 ? void 0 : res.content.filter(function (deal) {
          return deal.id === dealId;
        });
        var otherDeals = res.content.filter(function (deal) {
          return deal.id !== dealId;
        });
        setBundleDeals(filteredDeals);
        setOtherBundleDeals(otherDeals);
        if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction = redux.dealAction) !== null && _redux$dealAction !== void 0 && _redux$dealAction.saveBundleDeals) {
          dispatch(redux.dealAction.saveBundleDeals({
            url: url,
            deals: res === null || res === void 0 ? void 0 : res.content
          }));
        }
        var bundleIds = filteredDeals.map(function (offer) {
          return offer.id;
        });
        var apiCall = Promise.all(bundleIds.map(function (id) {
          return winnreAuth === null || winnreAuth === void 0 ? void 0 : winnreAuth({
            method: "GET",
            url: "/winnre/user/deals/".concat(id)
          });
        }));
        apiCall.then(function (res) {
          setBundleDealDetails(res);
        });
      });
    }
  };
  var getSimilarOffersByCategory = function getSimilarOffersByCategory(dealID, categoryID, rewardCategoryID, tagID) {
    var _stateDeals$similarOf;
    var oldCartData = isPoints ? localStorage.getItem("cartData_reloyrewardpoints") : localStorage.getItem("cartData");
    var cartData = {
      cartValues: [],
      totalPoints: 0,
      totalProduct: 0
    };
    if (oldCartData) {
      cartData = JSON.parse(oldCartData);
    }
    // const similarUrl = `/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=${categoryID}&pageSize=10${
    //     categoryID == 8 ? `&tagList=${tagID}` : ''
    // }${isRewards ? '&rewardsPage=true' : ''}${
    //     isRewards && cartData.totalPoints > 0
    //         ? `&cartValue=${cartData.totalPoints}`
    //         : ''
    // }`;
    var similarUrl = "/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&".concat(isRewards ? "rewardCategories=".concat(rewardCategoryID) : "categoryList=".concat(categoryID), "&pageSize=10").concat(categoryID == 8 ? "&tagList=".concat(tagID) : "").concat(isRewards ? "&rewardsPage=true" : "").concat(isRewards && cartData.totalPoints > 0 ? "&cartValue=".concat(cartData.totalPoints) : "");
    console.log("url", similarUrl);
    console.log("url", isRewards);
    var similarOffers = ((_stateDeals$similarOf = stateDeals.similarOffers) === null || _stateDeals$similarOf === void 0 ? void 0 : _stateDeals$similarOf[similarUrl]) || null;
    if (similarOffers) {
      // Use cached deals if available
      console.log("Using cached similar deals:", similarOffers);
      setSimilarOffers(similarOffers.filter(function (deal) {
        return deal.id !== dealID;
      }));
    } else {
      fetchSimilarDeals({
        isEncryptedResponse: isAuthenticated ? true : false,
        url: similarUrl,
        method: "get",
        isFormData: true
      }, function (res) {
        if (isRewards && totalRewardspoint > 0) {
          var _res$content;
          var filteredRewards = res === null || res === void 0 || (_res$content = res.content) === null || _res$content === void 0 ? void 0 : _res$content.filter(function (val) {
            return val.points < totalRewardspoint - cartData.totalPoints && val.id !== dealID;
          });
          setSimilarOffers(filteredRewards);
        } else {
          var _redux$dealAction2;
          if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction2 = redux.dealAction) !== null && _redux$dealAction2 !== void 0 && _redux$dealAction2.saveSimilarDeals) {
            dispatch(redux.dealAction.saveSimilarDeals({
              url: similarUrl,
              deals: res === null || res === void 0 ? void 0 : res.content
            }));
          }
          setSimilarOffers(res === null || res === void 0 ? void 0 : res.content.filter(function (deal) {
            return deal.id !== dealID;
          }));
        }
      });
    }
  };
  var getOffersOfTheMonth = function getOffersOfTheMonth() {
    var _stateDeals$monthOffe;
    var url = "/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&categoryList=1,2,3,5&pageSize=10&tagList=52";
    var monthOffers = ((_stateDeals$monthOffe = stateDeals.monthOffers) === null || _stateDeals$monthOffe === void 0 ? void 0 : _stateDeals$monthOffe[url]) || null;
    if (monthOffers) {
      console.log("Using cached month deals:", monthOffers);
      setTopOffers(monthOffers !== null && monthOffers !== void 0 ? monthOffers : []);
    } else {
      winnreAuth === null || winnreAuth === void 0 || winnreAuth({
        method: "GET",
        url: url
      }).then(function (data) {
        var _redux$dealAction3;
        if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction3 = redux.dealAction) !== null && _redux$dealAction3 !== void 0 && _redux$dealAction3.saveOfferOfMonthDeals) {
          dispatch(redux.dealAction.saveOfferOfMonthDeals({
            url: url,
            deals: data === null || data === void 0 ? void 0 : data.content
          }));
        }
        setTopOffers((data === null || data === void 0 ? void 0 : data.content) || []);
      });
    }
  };
  var getSameBrandOffers = function getSameBrandOffers(dealID, vendorID) {
    var _stateDeals$brandOffe;
    var url = "/winnre/user/deals/filter-v2?status=PUBLISHED&isAscending=false&sortBy=priority&pageSize=10&vendorIds=".concat(vendorID);
    var brandOffers = ((_stateDeals$brandOffe = stateDeals.brandOffers) === null || _stateDeals$brandOffe === void 0 ? void 0 : _stateDeals$brandOffe[url]) || null;
    if (brandOffers) {
      console.log("Using cached same brand deals:", brandOffers);
      setSameBrandOffers(brandOffers.filter(function (deal) {
        return deal.id !== dealID;
      }) || []);
    } else {
      winnreAuth === null || winnreAuth === void 0 || winnreAuth({
        method: "GET",
        url: url
      }).then(function (data) {
        var _redux$dealAction4;
        if (dispatch && redux !== null && redux !== void 0 && (_redux$dealAction4 = redux.dealAction) !== null && _redux$dealAction4 !== void 0 && _redux$dealAction4.saveSameBrandOffersDeals) {
          dispatch(redux.dealAction.saveSameBrandOffersDeals({
            url: url,
            deals: (data === null || data === void 0 ? void 0 : data.content) || []
          }));
        }
        setSameBrandOffers(((data === null || data === void 0 ? void 0 : data.content) || []).filter(function (deal) {
          return deal.id !== dealID;
        }));
      });
    }
  };
  useEffect(function () {
    var _deal$category, _deal$rewardCategory, _deal$tags$;
    if ((deal === null || deal === void 0 ? void 0 : deal.id) > 0) getSimilarOffersByCategory(deal.id, deal === null || deal === void 0 || (_deal$category = deal.category) === null || _deal$category === void 0 ? void 0 : _deal$category.id, deal === null || deal === void 0 || (_deal$rewardCategory = deal.rewardCategory) === null || _deal$rewardCategory === void 0 ? void 0 : _deal$rewardCategory.id, deal === null || deal === void 0 || (_deal$tags$ = deal.tags[0]) === null || _deal$tags$ === void 0 ? void 0 : _deal$tags$.id);
  }, [isRewardRefreshing]);
  useEffect(function () {
    getDealDetails();
    if (isAuthenticated) {
      getOffersOfTheMonth();
    }
  }, [dealId, isAuthenticated, isPublicView]);
  return {
    deal: deal,
    loadingDeal: loadingDeal,
    similarOffers: similarOffers,
    topOffers: topOffers,
    sameBrandOffers: sameBrandOffers,
    bundleDeals: bundleDeals,
    bundleDealDetails: bundleDealDetails,
    faultyDeal: faultyDeal,
    otherBundleDeals: otherBundleDeals
  };
};
export default useData;